import { CameraEvent } from 'features/dashboard/types/camera-event'
import { Dialog } from 'primereact/dialog'
import React from 'react'
import MercosulPlate from 'shared/mercosul-plate/mercosul-license-plate'
import TechnicalMetadataCard from './dashboard-notification-metadata-dialog'
import VehicleInfoCard from './dashboard-notification-anpr-dialog'
import BasicInfoCard from './dashboard-notification-basic-info-dialog'
import PersonInfoCard from './dashboard-notification-ahcr-dialog'

export interface DashboardNotificationDialogProps {
  visible: boolean
  onHide: () => void
  selectedEvent: CameraEvent | null
  selectedImage: string | null
}

const DashboardNotificationDialog: React.FC<DashboardNotificationDialogProps> = ({
  visible,
  onHide,
  selectedEvent,
  selectedImage,
}) => {
  const isAHCREvent =
    selectedEvent?.eventType === 'AHCRDetection' ||
    selectedEvent?.metadata?.VehicleType === 'people'

  const metadata = selectedEvent?.metadata ?? {}

  return (
    <Dialog
      visible={visible}
      style={{ width: '90vw', maxWidth: '1000px' }}
      onHide={onHide}
      modal
      className='image-detail-dialog'
      header={
        <div className='dialog-header-content'>
          <div className='dialog-icon'>
            <i className={`pi ${isAHCREvent ? 'pi-user' : 'pi-car'}`} />
          </div>
          <div>
            <h3>{isAHCREvent ? 'Detecção de Pessoa' : 'Detecção de Veículo'}</h3>
            <p>Informações completas do evento capturado</p>
          </div>
        </div>
      }
    >
      {selectedEvent && (
        <div className='image-dialog-content'>
          <div className='image-section'>
            <div className='image-container'>
              <img
                src={selectedImage || ''}
                alt={isAHCREvent ? 'Detecção de Pessoa' : 'Detecção de Veículo'}
                className='modal-image'
              />
              {!isAHCREvent && metadata.LicensePlate && (
                <div className='image-badge'>
                  <MercosulPlate licensePlate={metadata.LicensePlate} size='M' />
                </div>
              )}
            </div>
          </div>

          <div className='details-section'>
            <BasicInfoCard
              cameraId={selectedEvent.cameraId}
              timestamp={selectedEvent.timestamp}
              eventType={selectedEvent.eventType}
              metadata={metadata}
            />

            {!isAHCREvent && <VehicleInfoCard metadata={metadata} />}

            {isAHCREvent && <PersonInfoCard metadata={metadata} />}

            <TechnicalMetadataCard metadata={metadata} />
          </div>
        </div>
      )}
    </Dialog>
  )
}

export default DashboardNotificationDialog
